import Phaser from "phaser";
import { BOARD_ASSETS } from "../assets";
import { setGameStatus } from "../status";
import { isArtLayoutCapture } from "../../artLayout";
import { STAGE } from "../view/stage";

export class BootScene extends Phaser.Scene {
  constructor() {
    super("BootScene");
  }

  preload(): void {
    const progress = this.add.graphics().setPosition(STAGE.width / 2, STAGE.height / 2);
    const drawProgress = (value: number) => {
      progress.clear().fillStyle(0x263d35).fillRoundedRect(-150, -8, 300, 16, 8);
      progress.lineStyle(2, 0xb9a57c).strokeRoundedRect(-150, -8, 300, 16, 8);
      if (value > 0) progress.fillStyle(0xe4cea0).fillRoundedRect(-146, -4, 292 * value, 8, 4);
    };
    if (!isArtLayoutCapture) {
      drawProgress(0);
      this.load.on(Phaser.Loader.Events.PROGRESS, drawProgress);
    }
    this.load.once(Phaser.Loader.Events.COMPLETE, () => {
      this.load.off(Phaser.Loader.Events.PROGRESS, drawProgress);
      progress.destroy();
    });
    this.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, (file: Phaser.Loader.File) => {
      setGameStatus("error", "Game art could not be loaded.");
      console.error("Failed to load game art:", file.src);
    });
    for (const asset of BOARD_ASSETS) {
      this.load.image(asset.key, `${import.meta.env.BASE_URL}${asset.path}`);
    }
  }

  create(): void {
    const missing = BOARD_ASSETS.map((asset) => asset.key)
      .find((key) => !this.textures.exists(key));
    if (missing) {
      setGameStatus("error", "Game art could not be loaded.");
      throw new Error(`Missing Phaser texture: ${missing}`);
    }
    this.scene.start(isArtLayoutCapture ? "BoardScene" : "StartScene");
  }
}
